import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchComponent implements OnInit {
    public inputValue: string;

    @Input() delay?: number;
    @Input() placeholder = 'SEARCH_PLACEHOLDER';

    @Output() search = new EventEmitter<string>();

    @ViewChild('searchInput') private readonly searchInput: any;

    private submittedValue: string;
    private readonly delayChange$: Subject<string>;

    private readonly DefaultDelayTime = 800;

    constructor() {
        this.delayChange$ = new Subject<string>();
    }

    ngOnInit(): void {
        this.delayChange$
            .pipe(untilDestroyed(this), debounceTime(this.delay || this.DefaultDelayTime))
            .subscribe(val => this.searchChange(val));
    }

    public delaySubmit(val: string): void {
        this.inputValue = val;
        this.delayChange$.next(val);
    }

    public instantSubmit(val: KeyboardEvent): void {
        const target = val.target as HTMLInputElement;
        this.searchChange(target.value);
    }

    public focus(): void {
        this.searchInput.nativeElement.focus();
    }

    public searchChange(val: string): void {
        if (this.submittedValue === val) {
            return;
        }

        this.submittedValue = val;
        this.search.emit(this.submittedValue);
    }

    public clear(): void {
        this.inputValue = '';
        this.searchChange(this.inputValue);
    }
}
